import { HttpLink, InMemoryCache } from "apollo-client-preset";
import { ApolloClient } from "apollo-client";
import { findIndex } from 'lodash'
import fire from '../components/App/fire';

let graphqlUrl = "https://data.visp.net/graphql";

const getURL = (snap) => {
  const index = findIndex(snap, endpoint => endpoint.active)
  return snap[index] ? snap[index].url : false
}

const getLink = () => {
  fire
    .database()
    .ref('endpoints')
    .orderByKey()
    .on('value', snapshot => {
      const url = getURL(snapshot.val())
      if (url) {
        graphqlUrl = url
      }
    })
  return new HttpLink({ uri: graphqlUrl })
}

const client = new ApolloClient({
  link: getLink(),
  cache: new InMemoryCache()
});

export default client